import { useRef } from 'react'
import { Modal } from 'react-daisyui'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/Button.tsx'
import { IconDiamond } from '@tabler/icons-react'

interface ProjectLimitModalProps {
  modalRef: React.RefObject<HTMLDialogElement>
}

export function useProjectLimitModal() {
  const modalRef = useRef<HTMLDialogElement>(null)
  const show = () => modalRef.current?.showModal()
  const close = () => modalRef.current?.close()
  return { modalRef, show, close }
}

export function isProjectLimitError(e: any): boolean {
  if (e?.response?.status !== 400) return false
  const data = e?.response?.data
  const msg = typeof data === 'string' ? data : data?.error || data?.detail || ''
  return typeof msg === 'string' && msg.toLowerCase().includes('project limit')
}

export function ProjectLimitModal({ modalRef }: ProjectLimitModalProps) {
  const navigate = useNavigate()

  function handleUpgrade() {
    modalRef.current?.close()
    navigate('/portal/subscription')
  }

  return (
    <Modal ref={modalRef} className="bg-neutral">
      <Modal.Header>
        <div className="flex flex-col items-center gap-3 pt-2">
          <div className="bg-primary bg-opacity-20 text-primary rounded-full p-4">
            <IconDiamond size={36} />
          </div>
          <span className="text-xl font-bold text-center">Projekt-Limit erreicht</span>
        </div>
        <form method="dialog">
          <button className="btn btn-sm btn-circle btn-ghost absolute right-5 top-5">✕</button>
        </form>
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-col gap-4 items-center">
          <p className="text-center text-base-content opacity-80">
            Du hast die maximale Anzahl an Projekten in deinem aktuellen Tarif erreicht. Schalte mehr Projekte frei, um weitere Galerien anzulegen.
          </p>
          <div className="flex flex-col gap-2 items-stretch w-full max-w-xs">
            <Button color="primary" onClick={handleUpgrade}>
              Mehr Projekte freischalten
            </Button>
            <form method="dialog">
              <Button color="ghost" className="w-full">Schließen</Button>
            </form>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}
